import { Dictionary } from "../system";

export class WebApplicationInformation {
  constructor(public url: string, public pattern: WebApplicationExecutePatterns, public postValues: Dictionary<string, string>, public postedData: any) {
  }
}

export enum WebApplicationExecutePatterns {
  Iframe,
  Get,
  AnalyzePostedData,
}
